import { connect } from 'react-redux'
import SubHead from './head'
import {
  getSharedPresentation,
  getCopyRequest
} from '../../../../stores/shared-presentation/shared-presentation.selectors'
import { copyPresentation } from '../../../../stores/shared-presentation/shared-presentation.actions'
import { withRouter } from 'react-router-dom'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const sharedPresentation = getSharedPresentation(state)
  const copyRequest = getCopyRequest(state)
  return {
    copying: copyRequest.pending,
    presentationId: sharedPresentation && sharedPresentation.presentation.id,
    title: sharedPresentation && sharedPresentation.presentation.title
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () =>
    dispatch(copyPresentation(stateProps.presentationId))
      .then(() => ownProps.history.push('/'))
      .catch(errorHandler)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(SubHead)
)
